import React from 'react';
import './styles.scss';
import { Text } from '../../text/Text.tsx';

type PopupProps = {
  onClose: () => void;
};

export const TypewriterLetter: React.FC<PopupProps> = ({ onClose }) => {
  return (
    <div className="wf-popup">
      <div className="popup-header">
        <Text variant="title3">{'Typewriter Letter'}</Text>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      </div>
      <div className="popup-body">
        {
          <iframe className='iframe'
            src="https://slavril.github.io/TypewriterLetter/"
            title="Typewriter Letter"
          />
        }
      </div>
    </div>
  );
};
